<template>
    <div>
        <v-btn v-ripple="false" :loading="loading" @click="$emit('click')" class="white--text drop-button button-danger-active" color="error">
            <slot></slot>
        </v-btn>
    </div>
</template>
<script>
    export default {
        props: ['to', 'href', 'loading'],
    }
</script>
<style>
    .disable-events {
        pointer-events: none
    }
</style>
